module.exports = __webpack_public_path__ + "img/plusedit.17c769fa.svg";